module.exports = __webpack_public_path__ + "images/fa-duotone-900.314e2724f029624a7167d3ef5198214a.svg";